import React from 'react';
import footerlogo from '../images/logo.webp';
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

function Footer() {
  return (
    <div>
      <footer className='container-xxl'>
        <div className='firstfooter'>
          <div className='image'>
            <img alt='footerlogo' src={footerlogo} className='img-fluid' />
          </div>
          <div className='social'>
            {/* <span>Follow Us</span> */}
            <div className='icons'>
              <a href='https://www.facebook.com/sudhanshu.batra.96' target='_blank' rel="noreferrer">
                <FaFacebook className='icon' />
              </a>
              <a href='https://www.linkedin.com/in/sudhanshubatra/' target='_blank' rel="noreferrer">
                <FaLinkedin className='icon' />
              </a>
              <a href='https://www.instagram.com/sudhanshubatraa/' target='_blank' rel="noreferrer">
                <FaInstagram className='icon' />
              </a>
              <a href='https://x.com/sudhanshubatraa' target='_blank' rel="noreferrer">
                <FaXTwitter className='icon' />
              </a>
            </div>
          </div>
        </div>
        <div className='secondfooter'>
          <p className='footertxt'>@ 2020 - 2026 DesignLanders. Crafting bold ideas into impactful designs. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}

export default Footer
